import type { AppRouteRecordRaw } from '@/router/types'

// The food module's sidebar routes are generated from system_menu.
// This file keeps the dynamic module registry aligned with system_module.name.
const foodRoutes: AppRouteRecordRaw[] = [
  {
    // AI应用中心「AI智慧餐饮」卡片同窗入口别名：卡片 homePath 经前缀归一后为 /catering/dashboard，
    // 重定向到统一管理真实路由（/ai-Application-center/catering/dashboard）
    path: '/catering/dashboard',
    component: () => import('@/views/catering/dashboard/index.vue'),
    name: 'CateringDashboardAlias',
    meta: {
      title: 'AI智慧餐饮',
      hidden: true
    }
  },
  {
    path: '/catering/redirect',
    component: () => import('@/views/catering/redirect/index.vue'),
    name: 'CateringRedirect',
    meta: {
      title: 'AI智慧餐饮',
      icon: 'ep:bowl',
      hidden: true
    }
  }
]

export default foodRoutes
